module.exports = __webpack_public_path__ + "static/media/final-logo.23e9a0cb.svg";